/** OskEmployeeRole of the API (sent as a number). */
export enum OskEmployeeRole {
  Boss = 0,
  Office = 1,
  Instructor = 2,
  Lecturer = 3,
}

export const OSK_EMPLOYEE_ROLE_LABELS: Record<OskEmployeeRole, string> = {
  [OskEmployeeRole.Boss]: 'Szef',
  [OskEmployeeRole.Office]: 'Pracownik biurowy',
  [OskEmployeeRole.Instructor]: 'Instruktor nauki jazdy',
  [OskEmployeeRole.Lecturer]: 'Wykładowca',
};

/** Who may do what - shown next to the role picker. */
export const OSK_EMPLOYEE_ROLE_DESCRIPTIONS: Record<OskEmployeeRole, string> = {
  [OskEmployeeRole.Boss]: 'Może wszystko w obrębie OSK, także dodawać i usuwać pracowników.',
  [OskEmployeeRole.Office]:
    'Dodaje kursantów, edytuje ich dane, przydziela dostępy, przygotowuje umowy i kursy oraz prowadzi grupy wykładowe.',
  [OskEmployeeRole.Instructor]:
    'Widzi przypisanych do siebie kursantów i grupy, które prowadzi, uruchamia z nimi wykłady i prowadzi swój kalendarz jazd.',
  [OskEmployeeRole.Lecturer]:
    'Widzi przypisanych do siebie kursantów i grupy, które prowadzi, uruchamia z nimi wykłady i planuje wykłady swoich grup w kalendarzu.',
};

export const OSK_EMPLOYEE_ROLE_OPTIONS = [
  OskEmployeeRole.Office,
  OskEmployeeRole.Instructor,
  OskEmployeeRole.Lecturer,
  OskEmployeeRole.Boss,
].map((value) => ({ value, label: OSK_EMPLOYEE_ROLE_LABELS[value] }));

/** Students and lecture groups are assigned only to instructors and lecturers. */
export function isTeachingRole(role: OskEmployeeRole): boolean {
  return role === OskEmployeeRole.Instructor || role === OskEmployeeRole.Lecturer;
}
